export const instanceConfig = {
    baseURL: `/api/v2`,
    timeout: 25000,
    withCredentials: true
}
